import React, { useEffect, useState } from 'react';
import motorspares from '../assets/motorspares.jpg';
import { API_URL_UPLOADS } from "../pages/config";

const TrendingItems = () => {
  const [trendingItems, setTrendingItems] = useState([]);

  useEffect(() => {
    const fetchTrendingProducts = async () => {
      try {
        const response = await fetch('http://localhost:3009/productdefinition/popular_products_by_category');
        const data = await response.json();
        setTrendingItems(data); // Store all fetched products
      } catch (error) {
        console.error("Error fetching trending products:", error);
      }
    };

    fetchTrendingProducts();
  }, []);

  return (
    <div className="container mb-5">
      <h3 className="mb-4">Trending</h3>
      <div className="d-flex flex-wrap flex-md-nowrap overflow-auto">
        {/* Display static Motor spares */}
        <div className="d-flex flex-column align-items-center me-3 mb-3" style={{ flex: '0 0 auto' }}>
          <img
            src={motorspares}
            className="img-fluid rounded-circle mb-2"
            alt="Motor spares"
            style={{ height: '120px', width: '120px' }}
          />
          <h5 className="text-center">Motor spares</h5>
        </div>

        {/* Display fetched products */}
        {trendingItems.map((item) => (
          <div key={item.product_id} className="d-flex flex-column align-items-center me-3 mb-3" style={{ flex: '0 0 auto' }}>
            <img
              src={`${API_URL_UPLOADS}/${item.uploaded_product_image_ref}`}
              className="img-fluid rounded-circle mb-2"
              alt={item.product_name}
              style={{ height: '120px', width: '120px' }}
            />
            <h5 className="text-center">{item.product_name}</h5>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TrendingItems;